import { ResultType } from "@careevolution/mydatahelps-cel";
import { AnswerFormat, DateAnswerFormat, FormItem, NumericAnswerFormat, QuestionStepDefinition, SurveyDefinition, TextChoiceAnswerFormat, ValuePickerAnswerFormat } from "../../../types/Survey";
import { calculatedFieldStepIdentifier } from "./calculatedFields";
import { hasFormItems } from "../../../helpers/survey";

export interface SurveyAnswerTypeMapping {
    resultIdentifier: string;
    stepIdentifier: string;
    answerType: ResultType;
}

export function getAnswerTypeMappings(surveyDefinition: SurveyDefinition): SurveyAnswerTypeMapping[] {
    let answerTypes: SurveyAnswerTypeMapping[] = [];

    surveyDefinition.steps?.forEach(step => {
        if (!step.identifier) { return; }
        if (step.type === "QuestionStep") {
            answerTypes.push({
                resultIdentifier: step.identifier,
                stepIdentifier: step.identifier,
                answerType: getAnswerTypeForAnswerFormat((step as QuestionStepDefinition).answerFormat)
            });
        } else if (hasFormItems(step)) {
            const formItems = step.formItems;
            formItems?.forEach((formItem: FormItem) => {
                if (!formItem.identifier || !step.identifier) { return; }
                answerTypes.push({
                    resultIdentifier: formItem.identifier,
                    stepIdentifier: step.identifier,
                    answerType: getAnswerTypeForAnswerFormat(formItem.answerFormat)
                });
            });
        }
    });

    surveyDefinition.calculatedFields?.forEach(field => {
        answerTypes.push({
            resultIdentifier: field.identifier,
            stepIdentifier: calculatedFieldStepIdentifier,
            answerType: field.returnType
        });
    });
    return answerTypes;
}

function getAnswerTypeForAnswerFormat(answerFormat?: AnswerFormat): ResultType {
    switch (answerFormat?.type) {
        case "BooleanAnswerFormat":
            return "Boolean";
        case "ContinuousScaleAnswerFormat":
        case "HeightAnswerFormat":
        case "WeightAnswerFormat":
        case "ScaleAnswerFormat":
            return "Decimal";
        case "DateAnswerFormat":
            if ((answerFormat as DateAnswerFormat).style == "DateAndTime") {
                return "Timestamp";
            } else {
                return "Date";
            }
        case "TimeOfDayAnswerFormat":
            return "TimeOfDay";
        case "NumericAnswerFormat":
            return (answerFormat as NumericAnswerFormat).style;
        case "TextChoiceAnswerFormat":
            const textChoiceAnswerFormat = answerFormat as TextChoiceAnswerFormat;
            const multipleAnswer = textChoiceAnswerFormat.style.startsWith("Multiple");
            const allNumeric = textChoiceAnswerFormat.textChoices.every(t => !isNaN(Number(t.value)));
            if (multipleAnswer) {
                return allNumeric ? "List<Decimal>" : "List<Text>";
            } else {
                return allNumeric ? "Decimal" : "Text";
            }
        case "ValuePickerAnswerFormat":
            const valuePickerAnswerFormat = answerFormat as ValuePickerAnswerFormat;
            const allNumericValuePicker = valuePickerAnswerFormat.textChoices.every(t => !isNaN(Number(t.value)));
            return allNumericValuePicker ? "Decimal" : "Text";
        default:
            return "Text";
    }
}